import { ActivatedUser } from "./activated-user";

export function DeactivatedUser({ type, companyName }: { type: string; companyName: string }) {
  const user = {
    id: "1",
    first_name: "Deactivated",
    last_name: "User",
    avatar: null,
    is_active: false,
    type,
    job_title: companyName,
    company: {
      id: "",
      name: companyName,
    },
  };

  return <ActivatedUser user={user} />;
}
